

































































































































































































































































































































































































import { profile as profilestore } from "@/store/index";
import { app } from "@/store/index";
import { configureOidc } from "@/store/services/security.service";
import { OidcAuth } from "vue-oidc-client/vue2";
import { VueTelInput } from "vue-tel-input";
import ContactViewModel from "@/models/ContactViewModel";
import useContact from "@/store/useContact";
import useConnectedAccount from "@/store/useConnectedAccount";
import moment from 'moment-timezone';
import {
    computed,
    defineComponent,
    onMounted,
    ref
} from "@vue/composition-api";
import ProfileViewModel from "@/models/ProfileViewModel";
import ConnectedAccountViewModel from "../models/ConnectedAccountViewModel";
import SubscriptionViewModel from "../models/SubscriptionViewModel";
import useSubscription from "../store/useSubscription";
import useUserSettings from "@/store/useUserSettings";
import UserSettingsViewModel from "@/models/UserSettingsViewModel";

export default defineComponent({
    name: "Profile",
    components: {
        VueTelInput,
        ConfirmDialog: () =>
            import(/* webpackChunkName: "settings" */ "./components/Dialogs/ConfirmDialog.vue")
    },
    setup() {
        const { update, getCaptain, nameRules, emailRules } = useContact();
        const { connectedAccount, get, remove, approve, lockout, allowGallery, denyGallery, allowUpload, denyUpload } = useConnectedAccount();
        const { getSubscription } = useSubscription();
        const { getUserSettings, updateUserSettings } = useUserSettings();
        const contact = ref<ContactViewModel>();
        const subscription = ref<SubscriptionViewModel>();
        const userSettings = ref<UserSettingsViewModel>();
        const valid = ref<boolean>(true);
        const showSuccess = ref<boolean>(false);
        const showRemove = ref<boolean>(false);
        const showLockout = ref<boolean>(false);
        const showAuthorize = ref<boolean>(false);
        const profileForm = ref<HTMLFormElement>();
        const userId = ref<string>("");
        const selectedTimezone = ref<string>("");
        const timezones = ref([]);

        const profile = computed<ProfileViewModel>(() => {
            return profilestore.profile;
        });

        const logout = () => {
            configureOidc().then((oidc: OidcAuth) => {
                oidc.signOut().then(() => {
                    window.location.href = "/Identity/Account/Logout";
                    //window.location.href = "/Identity/Account/Logout?returnUrl=%2FHome";
                });
            });
        };

        const initSave = () => {
            if (profileForm.value) {
                valid.value = profileForm.value.validate();
                if (valid.value && profile.value) {
                    profilestore.Update(profile.value);
                    update(contact.value).then(() => {
                        showSuccess.value = true;
                    });
                }
            }
        };

        const vueTel = {
            phone: "",
            props: {
                autoFormat: true,
                autoDefaultCountry: true,
                dropdownOptions: {
                    showDialCodeInList: true,
                    showDialCodeInSelection: false,
                    showFlags: true,
                    showSearchBox: true,
                    width: '300px',
                },
                ignoredCountries: ["KP", "RU"],
                inputOptions: {
                    autocomplete: 'on',
                    showDialCode: true,
                    placeholder: 'Enter phone number',
                    required: true,
                },
                mode: "international",
                preferredCountries: ["DK", "NO", "SE"],
                validCharactersOnly: true,
            }
        };

        const goBack = () => {
            window.history.back();
        };

        const successOk = () => {
            showSuccess.value = false;
        };

        const manageAcc = () => {
            window.location.href = "/Identity/Account/Manage";
        };

        const manageSubscription = () => {
            window.open("https://billing.stripe.com/p/login/test_cN2aFac1ngye556dQQ", "_blank");
        };

        const deleteConnectedAccount = (connectedAccount: ConnectedAccountViewModel) => {
            userId.value = connectedAccount.userId;
            showRemove.value = true;
        };

        const changeGalleryAccess = (connectedAccount: ConnectedAccountViewModel) => {
            userId.value = connectedAccount.userId;

            if (connectedAccount.hasGalleryAccess) {
                allowGallery(userId.value).then(() => {
                    get();
                    app.success = "Galerry access allowed. Changes may take up to 90s to take effect.";
                })
            } else {
                denyGallery(userId.value).then(() => {
                    get();
                    app.success = "Galerry access denied. Changes may take up to 90s to take effect.";
                })
            }
        };

        const changeUploadAccess = (connectedAccount: ConnectedAccountViewModel) => {
            userId.value = connectedAccount.userId;

            if (connectedAccount.hasUploadAccess) {
                allowUpload(userId.value).then(() => {
                    get();
                    app.success = "Upload access allowed. Changes may take up to 90s to take effect.";
                })
            } else {
                denyUpload(userId.value).then(() => {
                    get();
                    app.success = "Upload access denied. Changes may take up to 90s to take effect.";
                })
            }
        };

        const authorizeAccount = (connectedAccount: ConnectedAccountViewModel) => {
            userId.value = connectedAccount.userId;
            showAuthorize.value = true;
        };

        const deauthorizeConnectedAccount = (connectedAccount: ConnectedAccountViewModel) => {
            userId.value = connectedAccount.userId;
            showLockout.value = true;
        };

        const lockoutOk = () => {
            lockout(userId.value).then(() => {
                get();
                showRemove.value = false;
                app.success = "Account locked out. Changes may take up to 90s to take effect.";
            });
        };

        const removeOk = () => {
            remove(userId.value).then(() => {
                get();
                showRemove.value = false;
                app.success = "Account removed. Changes may take up to 90s to take effect.";
            });
        };

        const authorizeOk = () => {
            approve(userId.value).then(() => {
                get();
                showAuthorize.value = false;
                app.success = "Account authorized. Changes may take up to 90s to take effect.";
            })
        };

        const dataUsage = computed<number>(() => {
            if (profile.value) {
                return parseInt(((profile.value.mBsUsed / profile.value.dataLimit) * 100).toFixed(0));
            }
            return 0;
        });

        const transactionUsage = computed<number>(() => {
            if (profile.value) {
                return parseInt(((profile.value.transactionsUsed / profile.value.transactionsLimit) * 100).toFixed(0));
            }
            return 0;
        });

        const formattedBillingStart = computed<string>(() => {
            return profile.value ? formatDateString(profile.value.billingStart) : 'N/A';
        });

        const formattedBillingEnd = computed<string>(() => {
            return profile.value ? formatDateString(profile.value.billingEnd) : 'N/A';
        });

        const formattedSubscriptionStart = computed<string>(() => {
            return subscription.value ? formatDateString(subscription.value.currentPeriodStart) : "N/A";
        });

        const formattedSubscriptionEnd = computed<string>(() => {
            return subscription.value ? formatDateString(subscription.value.currentPeriodEnd) : 'N/A';
        });

        const billingInterval = computed<string>(() => {
            return subscription.value ? capitalizeFirstLetter(subscription.value.billingInterval + "ly") : 'N/A';
        });

        const formattedRenewalDate = computed<string>(() => {
            return subscription.value ? formatDateString(subscription.value.currentPeriodEnd) : 'N/A';
        });

        const formattedSubscribedSinceDate = computed<string>(() => {
            return subscription.value ? formatDateString(subscription.value.subscriptionStartDate) : 'N/A';
        });

        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
        }

        function formatDateString(dateString: string): string {
            const date = new Date(dateString);
            const day = date.getDate();
            const month = date.toLocaleString('en-US', { month: 'long' });
            const year = date.getFullYear();

            let daySuffix = 'th';
            if (day === 1 || day === 21 || day === 31) {
                daySuffix = 'st';
            } else if (day === 2 || day === 22) {
                daySuffix = 'nd';
            } else if (day === 3 || day === 23) {
                daySuffix = 'rd';
            }

            return `${day}${daySuffix} of ${month}, ${year}`;
        }

        const updateTimezone = () => {
            if (timezones.value.includes(selectedTimezone.value)) {
                userSettings.value.timezone = selectedTimezone.value;
                updateUserSettings(userSettings.value).then(() => {
                    app.success = "Captain timezone updated";
                });
            }
        };

        getUserSettings().then((value: UserSettingsViewModel) => {
            userSettings.value = value;
            selectedTimezone.value = userSettings.value.timezone;
        });

        getSubscription().then((model: SubscriptionViewModel) => {
            subscription.value = model;
        });

        onMounted(() => {
            profilestore.Get().then(() => {
                getCaptain("elCapitano").then((model: ContactViewModel) => {
                    if (model != null) {
                        contact.value = model;
                    } else {
                        contact.value = new ContactViewModel();
                    }
                });
            });
            timezones.value = moment.tz.names();
        });

        return {
            profile,
            profileForm,
            logout,
            manageAcc,
            successOk,
            initSave,
            showSuccess,
            showRemove,
            showLockout,
            showAuthorize,
            deleteConnectedAccount,
            lockoutOk,
            removeOk,
            deauthorizeConnectedAccount,
            vueTel,
            contact,
            nameRules,
            emailRules,
            goBack,
            authorizeAccount,
            authorizeOk,
            connectedAccount,
            dataUsage,
            transactionUsage,
            valid,
            formattedBillingStart,
            formattedBillingEnd,
            formattedSubscriptionStart,
            formattedSubscriptionEnd,
            formattedRenewalDate,
            formattedSubscribedSinceDate,
            billingInterval,
            manageSubscription,
            timezones,
            selectedTimezone,
            updateTimezone,
            changeGalleryAccess,
            changeUploadAccess,
        };
    },
    data: () => ({
        isValid: false,
    }),
    methods: {
        phoneObject: function (object) {
            if (object.valid === true) {
                this.isValid = true;
            } else {
                this.isValid = false;
            }
        },
    }
});
